import { render, staticRenderFns } from "./lessonplan.vue?vue&type=template&id=10c1e31a&"
import script from "./lessonplan.vue?vue&type=script&lang=js&"
export * from "./lessonplan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports